type TSVGProps = React.ComponentPropsWithoutRef<'svg'>;

export const HamburgerIcon = (props: TSVGProps): JSX.Element => {
  return (
    <svg
      data-testid="hamburger"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 18H13M20 6H4H20ZM20 12H4H20Z"
        stroke="#314259"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
